import { Row, Col, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import Column from "../Column/Column";

/**
 * A loading animation used on the Card component
 * @param {number} rows - The number of rows to display in the animation
 */
const LoadingSkeleton = function (props) {
  const { columnId, cardBodyId, isListing, rows, header, className, noShadow, bodyClasses = "" } = props;

  // Function to draw the 'card skeleton'
  let rowCount = 3; // The number of rows that will be drawn = 3, unless otherwise specified.
  if (rows != null) rowCount = rows;

  let Header = "";
  if (header != null)
    Header = (
      <Row>
        <Col className="mb-3 ">
          <h5 className="mb-0">{header}</h5>
        </Col>
      </Row>
    );

  const Rows = [];
  for (let i = 0; i < rowCount; i += 1) {
    Rows.push(
      // <Row key={i} className="skeleton-row">
      <Row key={i} className={`skeleton-row ${i === 0 ? "pt-1" : ""}`} data-testid="skeleton-row">
        <span key={1} className="skeleton" />
        <span key={2} className="skeleton" />
        <span key={3} className="skeleton" />
      </Row>,
    );
  }

  /// allow adding other classes (e.g col width or other classes)
  let classNameProp = "pl-16 pr-16";
  if (className != null) classNameProp = className;

  return (
    <Row data-testid="loading-skeleton">
      <Column className={classNameProp} data-testid={columnId}>
        <Card className="skeleton-card" style={{ boxShadow: noShadow && "none" }}>
          <Card.Body data-testid={cardBodyId} className={`${isListing ? "p-0" : ""} ${bodyClasses}`}>
            {Header}
            {Rows}
          </Card.Body>
        </Card>
      </Column>
    </Row>
  );
};

LoadingSkeleton.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isListing: PropTypes.bool,
  columnId: PropTypes.string,
  cardBodyId: PropTypes.string,
  noShadow: PropTypes.bool,
  bodyClasses: PropTypes.string,
};

LoadingSkeleton.defaultProps = {
  className: null,
  rows: 3,
  header: "",
  isListing: false,
  columnId: null,
  cardBodyId: null,
  noShadow: false,
  bodyClasses: "",
};

export default LoadingSkeleton;
